module.exports = __webpack_public_path__ + "img/scoreboard.e0146ae2.svg";